var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-checkbox',{class:_vm.class_name != null && _vm.class_name != undefined ? _vm.class_name : 'md-accent',model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }